export default function authMiddleware(to, from, next) {
  const token = localStorage.getItem('token');

  if (token) {
    next('/account/statistic');
  } else {
    next()
  }
}